<template lang="pug">
  .container-error
    .item
      h1
        font-awesome-icon.item-icon(icon="ban")
        span {{ $t('ERROR 400!')}}
    .item.description
      h4 {{ $t('Incorrect request')}}
      h4
        .warning {{ $t(ErrorData.data.message) }}
        .warning {{ $t(ErrorData.data) }}
      h6 {{ ErrorData.config.url}}
    .item
    .item.item-acknowledge
      el-button(id="Error400-okButton" type="warning", size="small", @click="ackError", plain)
        span {{ $t('OK') }}
</template>
<script>
export default {
  props: ['error'],
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    ackError () {
      this.$store.dispatch('Error/deleteAxiosError')
      this.$emit('ackError')
    }
  },
  computed: {
    ErrorData () {
      return this.$store.state.Error.axios_error
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
@import "./error.scss";
</style>



// WEBPACK FOOTER //
// src/components/Error/error400.vue